import type { MRT_ColumnDef } from "mantine-react-table-open";
import { MantineRoundedNumberCell } from "../../../../../mantine/mrt/components/cell/MantineRoundedNumberCell";
import { ctPerKWhToEuroPerMWh } from "../../../../../utils/energydata/energyUnits";
import type {
  EnergyPriceUnits,
  EnergyRevenuesListItem
} from "../../../RevenueMonitoring.types";
import { CustomTableHeader } from "../CustomTableCell/CustomTableHeader";
import { NullCell } from "../CustomTableCell/NullCell";
import { getEnergyUnitHeaderText } from "../EnergyRevenuesTable";
import { calculateRevenueCtPerKwh } from "../utils/calculateRevenuePerKwh";

export function getRevenuePerKwhColumn(
  energyPriceUnit: EnergyPriceUnits
): MRT_ColumnDef<EnergyRevenuesListItem> {
  return {
    id: "revenue_group",
    header: "",
    mantineTableHeadCellProps: {
      className: "column-group-header-border-left"
    },
    columns: [
      {
        id: "revenue_per_kwh",
        header: getEnergyUnitHeaderText("revenue_per_kwh", energyPriceUnit),
        enableHiding: false,
        size: 220,
        minSize: 140,
        accessorFn: (row) => {
          const value = calculateRevenueCtPerKwh(row);

          if (value === null) {
            return null;
          }

          return energyPriceUnit === "€/MWh"
            ? ctPerKWhToEuroPerMWh(value)
            : value;
        },
        mantineTableHeadCellProps: {
          className: "column-header-border-left"
        },
        mantineTableBodyCellProps: {
          className: "column-body-border-left"
        },
        mantineTableFooterCellProps: {
          className: "column-body-border-left"
        },
        Header: CustomTableHeader,
        Cell: ({ cell }) => {
          const value = cell.getValue<number | null>();
          if (value === null) {
            return <NullCell />;
          }
          return (
            <MantineRoundedNumberCell
              decimalScale={3}
              extraSpaceRight
              value={cell.getValue<number>()}
            />
          );
        },
        filterVariant: "range-slider",
        mantineFilterRangeSliderProps: {
          minRange: 0.1,
          step: 0.1
        }
      }
    ]
  };
}
